import { LuMessageCircle } from 'react-icons/lu'
import { Link } from 'react-router'
import { ROUTES } from '@/constants/routes'

export const CtaSection = () => (
  <section aria-labelledby="enquiry-heading" className="bg-base-50 px-6 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-4xl text-center">
      <h2
        id="enquiry-heading"
        className="font-display text-3xl leading-tight tracking-tight text-base-900 sm:text-4xl lg:text-5xl"
      >
        A thoughtful next step
        <br />
        for your wellbeing.
      </h2>
      <p className="mx-auto mt-6 max-w-lg text-base leading-7 text-base-600">
        Begin with a focused assessment or a personalised herbal consultation. Kandake will review
        your enquiry and help you choose the most appropriate next step.
      </p>
      <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-7">
        <Link
          to={`${ROUTES.CONTACT}?service=herbal-consultation`}
          className="inline-flex min-h-12 w-full items-center justify-center rounded-full bg-green-700 px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4 sm:w-auto"
        >
          <LuMessageCircle aria-hidden="true" className="mr-3 h-4 w-4 shrink-0" />
          Enquire About a Consultation
        </Link>
        <Link
          to={ROUTES.CONTACT}
          className="inline-flex min-h-12 items-center text-sm text-green-700 underline underline-offset-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700"
        >
          Have a question? Get in touch
        </Link>
      </div>
      <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-green-700">
        <Link
          to={`${ROUTES.CONTACT}?service=bio-scan`}
          className="inline-flex min-h-11 items-center underline underline-offset-4"
        >
          Enquire About a Bio-Scan
        </Link>
        <Link
          to={ROUTES.WORK_WITH_ME}
          className="inline-flex min-h-11 items-center underline underline-offset-4"
        >
          3 Month Integrated Health Programme
        </Link>
        <Link
          to={ROUTES.ABOUT}
          className="inline-flex min-h-11 items-center underline underline-offset-4"
        >
          Read Kandake’s story
        </Link>
        <Link
          to={ROUTES.PRODUCTS}
          className="inline-flex min-h-11 items-center underline underline-offset-4"
        >
          Enquire about herbal products
        </Link>
      </div>
    </div>
  </section>
)
